import globals from "../globals.js"
import axios from "axios"
export default {
    data(){
        return{
        }
    },
    methods: {
        async createCampaignData(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_API + "/campaign/", params)
                    if (response.data.status_id == 1) {
                        console.log("hi3")
                        resolve(response.data)
                    } else {
                        console.log("hi4")
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    console.log("hi5")
                    reject(error.response.data.reason)
                }
            })
        },
        async getCampaignList(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_API + "/campaign/list", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                }
            })
        },
        async getCampaignListDashboards(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_API + "/campaign/dashboard/list", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                }
            })
        },
        async getCampaignDetails(campaign_id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_API + "/campaign/"+campaign_id);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getCampaignStatisticsData(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_API + `/campaign/dashboard/statistics?category_id=${params.category_id}&type=${params.type}`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getCampaignTypeData(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_API + `/campaign/dashboard/analytics?period=${params.period}&between=${params.between}`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getCampOpenCountAPI(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_API + "/campaign/dashboard/open/count",params);
                    console.log(response)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getAnalyticsData(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_API + `/campaign/analytics?category_id=${params.category_id}&start_date=${params.start_date}&type=${params.type}&campaign_id=${params.campaign_id}`);
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async deleteCampaignsByID(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_API + "/campaign/delete", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async updateCampaignsByID(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_API + `/campaign/update/${params.id}`, params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async callApproveRejectCampaignAPI(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_API + "/campaign/approval", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async saveCampaignNotes(params){
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_API + `/campaign/note`, params)
                    if(response.data.status_id == 1){
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                    }
                } catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/mixins/campaign.js